module.exports = __webpack_public_path__ + "img/icon-search-unfocus.7778a8a2.svg";